import { DtoBase } from "../DtoBase";
import { List } from "../../DiscoveryEngine.TS/Utils/List";
import { ObjSerUtils } from "../../DiscoveryEngine.TS/Serialization/ObjSerUtils";
import { ShareDto } from './ShareDto';
import { NetViewTreeDto } from '../NetViews/NetViewTreeDto';

export class GetSharesResultDto extends DtoBase {

	public SourceShares: List<ShareDto>;
	public TargetShares: List<ShareDto>;
	public TargetNetViewTree: NetViewTreeDto;

	constructor() {
		super();

		this.Clear();
	}

	public Clear(): void {
		this.SourceShares = new List<ShareDto>();
		this.TargetShares = new List<ShareDto>();
		this.TargetNetViewTree = new NetViewTreeDto();
	}

	public get HasSourceShares(): boolean {
		return (!!this.SourceShares && this.SourceShares.Count > 0);
	}

	public get HasTargetShares(): boolean {
		return (!!this.TargetShares && this.TargetShares.Count > 0);
	}

	public get HasTargetNetViewTree(): boolean {
		return (!!this.TargetNetViewTree && this.TargetNetViewTree.HasNetViews);
	}

	public Write(obj: any, context: any): void {
		obj.get_shares_result = {};
		obj = obj.get_shares_result;

		super.Write(obj, context);

		if (this.HasSourceShares) {
			obj.source_shares = [];
			ObjSerUtils.WriteObjSerCollection(obj.source_shares, this.SourceShares, context);
		}

		if (this.HasTargetShares) {
			obj.target_shares = [];
			ObjSerUtils.WriteObjSerCollection(obj.target_shares, this.TargetShares, context);
		}

		if (this.HasTargetNetViewTree) {
			this.TargetNetViewTree.Write(obj, context);
		}
	}

	public Read(obj: any, context: any): void {
		if (!obj.get_shares_result)
			throw new Error();
		obj = obj.get_shares_result;

		super.Read(obj, context);

		if (obj.source_shares !== undefined) {
			this.SourceShares.Clear();
			ObjSerUtils.ReadObjSerCollection(obj.source_shares, this.SourceShares,
				(value: any) => new ShareDto(), context);
		}

		if (obj.target_shares !== undefined) {
			this.TargetShares.Clear();
			ObjSerUtils.ReadObjSerCollection(obj.target_shares, this.TargetShares,
				(value: any) => new ShareDto(), context);
		}

		if (obj.net_view_tree !== undefined) {
			this.TargetNetViewTree.Read(obj, context);
		}
	}

}
